<template>
  <span
    v-if="isRelevant"
    class="wt-transcribe-button"
    v-tooltip="$_tooltip_onToggle"
    ref="tooltipBody"
  >
    <i class="wticon wticon-Subtitles2" />

    <span
      :class="['-button', isEnabled ? 'wt2-link' : '-inactive']"
      @click="$_onClick_Link"
    >
      <template v-if="showTranscribingState">
        Transcribing<wt-ellipsis-animation />
      </template>
      <template v-else>
        {{ 'transcribe.shortTitle' | culture }}
      </template>
    </span>

    <transcribe-subtitles-toggle />
  </span>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import wtTranscribe from 'v/Transcribe/Transcribe.vue';
import storyViewBus from 'views/Story/storyViewBus.js';
import _ from '#/lodash-extended';
import { isAssetCandidateForTranscribe } from 'v/Story/Timeline/api/transcription';
import { getTranscriptEditableAssets } from 'v/Story/Timeline/api/asset';
import TranscribeSubtitlesToggle from './TranscribeSubtitlesToggle.vue';
import app from '#/app';

export default Vue.extend({
  name: 'wt-transcript-button',
  components: {
    TranscribeSubtitlesToggle,
  },

  computed: {
    ...mapState({
      selectedAssets: (state) => state.story.selectedAssets,
      transcriptions: (state) => state.story.transcriptions,
      enableVOSubtitles: (state) => state.story.enableVOSubtitles,
    }),
    ...mapGetters(['hasAudioOnTimeline', 'isSomeTranscribing']),
    ...mapState('timemachine', {
      tmAudio: (state) => state.trackLayer.audio,
    }),
    ...mapGetters('timemachine', [
      'shouldShow_TrackLayerAudio',
      'visualsWithPotentialTranscript',
      'visualsWithExistingTranscript',
    ]),

    hasVisualCandidatesInSelected() {
      return _.some(this.selectedAssets, (asset) => {
        return isAssetCandidateForTranscribe(asset);
      });
    },

    hasVisualCandidatesOnTimeline() {
      return !_.isEmpty(this.visualsWithPotentialTranscript);
    },

    isRelevant() {
      return (
        this.shouldShow_TrackLayerAudio ||
        this.hasVisualCandidatesInSelected ||
        this.hasVisualCandidatesOnTimeline
      );
    },

    isEnabled() {
      return (
        this.enableVOSubtitles &&
        (this.hasAudioOnTimeline || this.hasVisualCandidatesOnTimeline)
      );
    },

    showTranscribingState() {
      return this.enableVOSubtitles && this.isSomeTranscribing;
    },

    $_tooltip_onToggle() {
      let title;
      let description;

      if (this.showTranscribingState) {
        title = 'subtitles.working.title';
        description = 'subtitles.working.description';
      } else if (this.enableVOSubtitles) {
        title = 'subtitles.on.title';
        description = 'subtitles.on.description';
      } else {
        title = 'subtitles.off.title';
        description = 'subtitles.off.description';
      }

      return {
        animation: false,
        wrapperClass: 'large -subtitle',
        trigger: 'hover',
        placement: 'top',
        delay: { show: 300, hide: 0 },
        title: `
          <div class="subtitles-tooltip">
            <div class="-title">${app.culture.get(title)}</div>
            <div class="-description">${app.culture.get(description)}</div>
          </div>
        `.normalizeSpace(),
        html: true,
      };
    },
  },

  watch: {
    enableVOSubtitles() {
      this.$nextTick(() => {
        if (!this._isDestroyed) {
          $(this.$refs.tooltipBody).tooltip('show');
        }
      });
    },
  },

  methods: {
    $_onClick_Link() {
      storyViewBus.$emit('svbPauseRcp');
      const list = getTranscriptEditableAssets(
        this.visualsWithExistingTranscript,
        this.tmAudio
      );

      app.showModal({
        type: 'custom',
        component: wtTranscribe,
        showCloseButton: false,
        closeOnEscape: true,
        wrapperClass: ['wt-transcribe-modal'],
        store: app.rootStore,
        componentPropsData: {
          opener: app.TRANSCRIPT_OPENER.TOOLBAR,
          list,
        },
      });
    },
  },
});
</script>

<style lang="scss">
.tooltip.wt-preset-tooltip.large.-subtitle {
  pointer-events: none;
  margin-top: 10px; // move it down

  .tooltip-inner {
    max-width: 240px; // make it wider (default 200)
  }
}
</style>
<style lang="scss" scoped>
.wt-transcribe-button {
  display: flex;
  align-items: center;
  justify-content: center;

  .wticon {
    font-size: 16px;
    display: inline-block;
  }

  .-button {
    user-select: none;
    margin: 0 10px;

    &.-inactive {
      cursor: default;
      pointer-events: none;
    }
  }
}
</style>
